module.exports = __webpack_public_path__ + "static/media/EllipseNotiInGroup.b346023c.svg";